import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { useRouteMatch } from 'react-router-dom';

import { brandOpaqueBackgroundLogo, brandConstants } from 'brand-config';
import Header from '../header/header';
import SystemStatus from 'core/components/system-status';
import ImpersonationBanner from 'core/components/impersonation-banner';
import AgencyClaimsBanner from 'core/components/agency-claims-banner';
import useSession from 'core/hooks/use-session';

import useStyles from './layout.styles';

const brand = brandConstants.SHORT_NAME?.toLowerCase();

const Layout = observer(({ children }) => {
  const session = useSession();
  const isCdComparison = !!useRouteMatch({
    path: [
      '/customer/:id/policy/:policyId/version-compare/:version',
      '/customer/:id/policy/:policyId/:policyPreviewId'
    ],
    exact: true
  });
  const classes = useStyles({ showHeader: session.isLoggedIn, brand, isCdComparison }) || {};

  // Apply the impersonation grayscale to #root (rather than <body>) so MUI4
  // portal content — modals, tooltips, snackbars — which mounts directly on
  // <body> outside #root, isn't subject to `filter`-induced containing-block
  // changes for fixed positioning. Those portal surfaces will stay in color;
  // pair this with an explicit banner once that lands.
  useEffect(() => {
    document.getElementById('root')?.classList.toggle('is-impersonating', !!session.isImpersonating);
  }, [session.isImpersonating]);

  return (
    <>
      {session.isLoggedIn ? (
        <Header />
      ) : (
        <img src={brandOpaqueBackgroundLogo} alt="gobranch" className={classes.logo} />
      )}
      <div className={classes.layout}>
        {session.isLoggedIn && <SystemStatus />}
        {session.isLoggedIn && <ImpersonationBanner />}
        {session.isLoggedIn && <AgencyClaimsBanner />}
        <div className={classes.container}>{children}</div>
      </div>
    </>
  );
});

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.object
};

export default Layout;
